







































































































































































import {
  Vue, Component, Mixins, Prop
} from 'vue-property-decorator';

import MyList from '@/mixins/list';

import SelectStadium from '@/components/selectstadium.vue';

import VipAdd from './detail_vip_add.vue';
import VipEdit from './detail_vip_edit.vue';
import VipBill from './detail_vip_bill.vue';

@Component({
  components: {
    SelectStadium,
    VipAdd,
    VipEdit,
    VipBill
  }
})
export default class extends Mixins(MyList) {
  @Prop() userId!: number;

  stadiumId = 0;

  oldData: any = {};

  dispatchType = 'users/vipcard';

  billModalVisible = false;

  showBillModal(id: number) {
    this.editId = id;
    this.billModalVisible = true;
  }

  hideBillModal() {
    this.billModalVisible = false;
  }

  showEditModal1(oldData: any) {
    this.editId = oldData.id;
    this.stadiumId = oldData.stadium_id;
    this.oldData = oldData;
    this.editModalVisible = true;
  }

  async mounted() {
    this.spinLoading = true;
    await this.loadData(
      {
        user_id: this.userId
      },
      false
    );

    this.spinLoading = false;
  }
}
